<ion-card>
  <ion-card-header>
    <ion-card-title>{{ "Empfehle die YES!APP" | translate }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p class="pb-normal">{{ "Deinen Freunden und Betroffenen aus Deinem Umfeld." | translate }}</p>
    <ion-button expand="block" fill="outline" (click)="onShare()">
      {{ "Jetzt Freunde einladen" | translate }}
    </ion-button>
  </ion-card-content>
</ion-card>
